<div class="bg-dark block-spacer-b">
    <ng-container *ngIf="banners.length">
      <section id="banner" class="mb-1h">
          <div class="container slider-container position-relative">
              <app-slider-banner  [sliders]="banners"></app-slider-banner>
          </div>
      </section>
    </ng-container>
    <section id="cards" class="mb-2h">
        <app-cards></app-cards>
    </section>
    <section>
        <div class="container">
            <div class="row justify-content-lg-between">
                <div class="col-lg-5 d-none">
<!--                    <div class="mb-2h">-->
<!--                        <h2 class="text-primary">-->
<!--                            Notícias-->
<!--                        </h2>-->
<!--                        <ul class="nav flex-column text-info">-->
<!--                            <li *ngFor="let noticia of noticias" class="nav-item">-->
<!--                                <a class="nav-link" [title]="noticia.descricao" [aria-label]="noticia.descricao"-->
<!--                                    [href]=" noticia.link">-->
<!--                                    <img src="/assets/images/icons/ic-list-arrow.svg" loading="lazy" width="7"-->
<!--                                        height="11" class="img-fluid me-0q" [alt]="noticia.descricao">-->
<!--                                    {{noticia.texto}}-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                    <div class="mb-3 mb-lg-0">-->
<!--                        <h2 class="text-primary">-->
<!--                            Eventos-->
<!--                        </h2>-->
<!--                        <ul class="nav flex-column text-info">-->
<!--                            <li *ngFor="let evento of eventos" class="nav-item">-->
<!--                                <a class="nav-link" [title]="evento.descricao" [aria-label]="evento.descricao"-->
<!--                                    [href]="evento.link">-->
<!--                                    <img src="/assets/images/icons/ic-list-arrow.svg" loading="lazy" width="7"-->
<!--                                        height="11" class="img-fluid me-0q" [alt]="evento.descricao">-->
<!--                                    {{evento.texto}}-->
<!--                                </a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->
                </div>
                <div class="col-lg-12">
                    <app-form-cotacao-veiculos codigoTemplate="cotacaoVeiculos" [concessionarias]="concessionarias" [politicaPrivacidade]="politicaPrivacidade"></app-form-cotacao-veiculos>
                    <p style="color: #999999; margin-top: 18px">
                        Protegemos sua privacidade: não utilizamos seus dados para enviar qualquer tipo de spam.
                    </p>
                </div>
            </div>
        </div>
    </section>
</div>
<section class="showroom block-spacer-y">
    <div class="container">
        <div class="row justify-content-lg-between align-items-lg-center">
            <div class="col-lg-auto order-lg-1">
                <picture>
                    <source srcset="/assets/images/img-showroom-lg.webp,
                        /assets/images/img-showroom-lg@2x.webp 2x" type="image/webp" media="(min-width: 1024px)">
                    <source srcset="/assets/images/img-showroom-lg.jpg,
                        /assets/images/img-showroom-lg@2x.jpg 2x" type="image/jpg" media="(min-width: 1024px)">
                    <source srcset="/assets/images/img-showroom.webp,
                        /assets/images/img-showroom@2x.webp 2x" type="image/webp" media="(max-width: 1023px)">
                    <source srcset="/assets/images/img-showroom.jpg,
                        /assets/images/img-showroom@2x.jpg 2x" type="image/jpg" media="(max-width: 1023px)">
                    <img src="data:image/png;base64, R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
                        alt="Uma van, um caminhão e um ônibus" title="Showroom Virtual Mercedes-Benz Star Online"
                        loading="lazy" width="454"
                         height="313" class="img-sanitize mb-2h mb-lg-0">
                </picture>
            </div>
            <div class="col-lg-6 order-lg-0">
                <div class="mb-2">
                    <h2 class="mb-1h">
                        Showroom Virtual Mercedes-Benz Star Online
                    </h2>
                    <p>
                        Nova plataforma de vendas, onde você pode comprar caminhões,
                        ônibus e Linha Sprinter, como também veículos seminovos da
                        SelecTrucks. Além de contar com ofertas de peças e serviços e
                        condições imperdíveis do Banco e Consórcio Mercedes-Benz. Tudo
                        muito prático, simples e rápido.
                    </p>
                </div>
                <div class="row">
                    <div class="col-auto">
                        <a href="https://showroommercedes-benz.com.br/" aria-label="Acesse já" title="Acesse já"
                            class="btn btn-block btn-info" target="_blank" rel="noopener">
                            Acesse já
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="block-spacer-y">
    <div class="container">
        <div class="row justify-content-lg-between align-items-lg-center">
            <div class="col-lg-auto">
                <picture>
                    <source srcset="/assets/images/img-about-lg.webp,
                        /assets/images/img-about-lg@2x.webp 2x" type="image/webp" media="(min-width: 1024px)">
                    <source srcset="/assets/images/img-about-lg.jpg,
                        /assets/images/img-about-lg@2x.jpg 2x" type="image/jpg" media="(min-width: 1024px)">
                    <source srcset="/assets/images/img-about.webp,
                        /assets/images/img-about@2x.webp 2x" type="image/webp" media="(max-width: 1023px)">
                    <source srcset="/assets/images/img-about.jpg,
                        /assets/images/img-about@2x.jpg 2x" type="image/jpg" media="(max-width: 1023px)">
                    <img src="data:image/png;base64, R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
                        alt="Caminhões" title="Sobre a Rodobens Veículos Comerciais" loading="lazy"
                         width="454"
                         height="313"
                        class="img-sanitize mb-2h mb-lg-0">
                </picture>
            </div>
            <div class="col-lg-6">
                <div class="mb-2">
                    <h2 class="mb-1h">
                        Sobre a Rodobens Veículos Comerciais
                    </h2>
                    <p>
                        Especialista em projetos de vida, a Rodobens possui um ecossistema único de distribuição, com
                        amplo portfólio de serviços financeiros, redes de parceiros e canais digitais. Atuando há mais
                        de 70 anos em todo o território nacional e com sede em São José do Rio Preto (SP), é reconhecida
                        por ter uma sólida cultura de inovação e tradição, ao entregar uma experiência completa aos seus
                        clientes, parceiros, colaboradores e fornecedores.
                    </p>
                    <p>
                        Por meio de nossas concessionárias de Veículos Comerciais, temos forte atuação em grandes
                        centros comerciais, estando presente em 11 estados brasileiros e 25 pontos de vendas, sendo a
                        maior rede de revenda Mercedes-Benz no Brasil.
                    </p>
                </div>
                <div class="row">
                    <div class="col-auto">
                        <a href="https://www.rodobens.com.br/?utm_source=site_mbb_vc&utm_medium=redirecionamento&utm_campaign=saiba_mais"
                            aria-label="Saiba mais" title="Saiba mais" class="btn btn-block btn-info" target="_blank" rel="noopener">
                            Saiba mais
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
